import { lazy } from "react";

const LoginPage = lazy(() => import("../../../features/login/LoginPage"));

export const authRoutes = [{ path: "/", component: LoginPage, private: false }];
